/*
* 菜单栏 Logo 组件
*/

import CNF from '../incs/Config';
import {
    Image,
    Flex,
    Typography,
    Tooltip,
    Space,
    theme,
    Tag,
} from 'antd';
import LOGO from '../images/logo.png';

const { Text } = Typography;

const XMenuLogo = ({ collapsed, serInfos }) => {
    const {
        token: {
            colorSuccess,
            colorSuccessBg,
        },
    } = theme.useToken();

    return (
        <Flex
            gap='small'
            align='center'
            style={{
                paddingLeft: collapsed ? 24 : 20,
                height: CNF.menuHeight,
                boxSizing: 'border-box',
                overflow: 'hidden',
                position: 'relative',
            }}
        >
            <Image
                draggable={false}
                width={30}
                preview={false}
                src={LOGO}
                style={{
                    position: 'absolute',
                    transform: 'translateY(-50%)',
                    width: 30,
                    height: 30,
                    userSelect: 'none',
                    willChange: 'transform', // 开启 GPU 加速，提升渲染平滑度
                }}
            />
            <Space
                style={{
                    opacity: collapsed ? 0 : 1,
                    visibility: collapsed ? 'hidden' : 'visible',
                    transition: 'opacity 0.8s ease', // 平滑淡入淡出
                    flexShrink: 0,            // 防止宽度被压缩
                    whiteSpace: 'nowrap',     // 禁止文字换行
                }}
            >
                <Text style={{ color: '#ffffff' }}>{CNF.projectCode}</Text>
                {
                    serInfos.length > 0 && serInfos[0].service_version === CNF.version ?
                        <Tooltip
                            title={<div>
                                {
                                    serInfos[0].description.split('\n').map((item, index) => <p key={index} style={{ margin: 0 }}>{item}</p>)
                                }
                            </div>}><Tag style={{ color: colorSuccess, cursor: 'pointer' }} color={colorSuccessBg}>{serInfos[0].service_version}</Tag></Tooltip>
                        :
                        <Text style={{ color: '#ffffff' }}>{CNF.version}</Text>
                }
            </Space>
        </Flex>
    );
}
export default XMenuLogo;